// extracted by mini-css-extract-plugin
export var actions = "_i8-d";
export var benefitCard = "_i8-a";
export var benefitIcon = "_i8-b";
export var benefitLabel = "_i8-c";
export var benefits = "_i8-9";
export var bodyText = "_i8-8";
export var closeButton = "_i8-2";
export var content = "_i8-3";
export var eyebrow = "_i8-4";
export var heading = "_i8-5";
export var image = "_i8-f";
export var imagePanel = "_i8-e";
export var modal = "_i8-0";
export var shell = "_i8-1";
export var title = "_i8-6";
export var titleOffer = "_i8-7";